require('slick-carousel');

export function tfvsl() {
  $('.tf-sl').slick({
    fade: true,
    arrows: false,
    autoplay: true,
    speed: 4000,
    pauseOnDotsHover: false,
  });
}
